/**
 * Ajax Search Alpine.js Component
 */

function ajaxSearch() {
    return {
        searchTerm: '',
        results: [],
        selectedIndex: -1,
        showResults: false,
        isLoading: false,
        error: null,
        totalFound: 0,
        searchUrl: '',
        searchInput: null,
        isFocused: false,

        /**
         * Initialize the component
         */
        init() {
            // Get reference to the search input
            this.searchInput = this.$refs.searchInput;

            // Add global keyboard event listener
            this.addGlobalKeyboardListener();
        },

        /**
         * Add global keyboard event listener for Ctrl+K
         */
        addGlobalKeyboardListener() {
            document.addEventListener('keydown', (e) => {
                // Check for Ctrl+K (or Cmd+K on Mac)
                if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                    e.preventDefault();
                    this.activateSearch();
                }
            });
        },

        /**
         * Activate search field and focus
         */
        activateSearch() {
            if (this.searchInput) {
                this.searchInput.focus();
                this.showResults = true;
                this.isFocused = true;

                // Select all text if there's already content
                if (this.searchTerm.length > 0) {
                    this.searchInput.select();
                }
            }
        },

        /**
         * Handle focus event
         */
        handleFocus() {
            this.isFocused = true;
            this.showResults = true;
        },

        /**
         * Handle blur event with delay
         */
        handleBlur() {
            setTimeout(() => {
                this.isFocused = false;
                this.showResults = false;
            }, 200);
        },

        /**
         * Perform AJAX search
         */
        async performSearch() {
            if (this.searchTerm.length < 2) {
                this.results = [];
                this.error = null;
                this.showResults = false;
                return;
            }

            this.isLoading = true;
            this.error = null;

            try {
                const formData = new FormData();
                formData.append('action', 'ajax_search');
                formData.append('search_term', this.searchTerm);
                formData.append('nonce', ajaxSearchData.nonce);

                const response = await fetch(ajaxSearchData.ajaxUrl, {
                    method: 'POST',
                    body: formData,
                });

                const data = await response.json();

                if (data.success) {
                    this.results = data.data.results;
                    this.totalFound = data.data.total_found;
                    this.searchUrl = data.data.search_url;
                    this.selectedIndex = -1;
                    this.showResults = true;
                } else {
                    this.error = data.data.message || 'Search failed';
                    this.results = [];
                }
            } catch (error) {
                this.error = 'Network error occurred';
                this.results = [];
            } finally {
                this.isLoading = false;
            }
        },

        /**
         * Navigate through results with arrow keys
         */
        navigateResults(direction) {
            if (this.results.length === 0) return;

            // Get visible results count (excluding the "View all" button)
            const visibleResultsCount = Math.min(this.results.length, 5); // Show max 5 results in dropdown

            this.selectedIndex += direction;

            // Wrap around only within visible results
            if (this.selectedIndex >= visibleResultsCount) {
                this.selectedIndex = 0;
            } else if (this.selectedIndex < 0) {
                this.selectedIndex = visibleResultsCount - 1;
            }
        },

        /**
         * Select a result
         */
        selectResult(result = null) {
            if (result) {
                window.location.href = result.url;
                return;
            }

            if (this.selectedIndex >= 0 && this.selectedIndex < this.results.length) {
                const selectedResult = this.results[this.selectedIndex];
                window.location.href = selectedResult.url;
            }
        },

        /**
         * Close results dropdown
         */
        closeResults() {
            this.showResults = false;
            this.selectedIndex = -1;
        },

        /**
         * Clear search
         */
        clearSearch() {
            this.searchTerm = '';
            this.results = [];
            this.error = null;
            this.showResults = false;
            this.selectedIndex = -1;

            // Focus back to input after clearing
            if (this.searchInput) {
                this.searchInput.focus();
            }
        },
    };
}
